import { useTheme } from "@emotion/react";

import Box from "./Box.jsx";
import Details from "./Details.jsx";
import useThemeProps from "./useThemeProps.jsx";

export default function DetailsBox(props) {
  // eslint-disable-next-line no-unused-vars
  const theme = useTheme();
  props = useThemeProps({ props, name: "DetailsBox" });
  let { color, components = {}, ...restProps } = props;
  return (
    <Details
      as={Box}
      color={color}
      style={{
        [[
          "&.wsui-is-expanded",
          "&:has(.wsui-details-summary-toggle.wsui-is-interactive:hover)",
          "&:has(.wsui-details-summary-toggle.wsui-is-interactive:focus-visible)",
        ]]: {
          backgroundColor: color ? [color, "hover"] : undefined,
        },
      }}
      components={{
        SummaryToggleIcon: {
          color: color ? [color, "text"] : "primary",
          size: 7.5,
        },
        ...components,
      }}
      {...restProps}
    />
  );
}
